export default "__VITE_ASSET__CNslxJ2f__"